import React, { useState, useEffect } from 'react';
import preval from 'preval.macro';
import { VERSION, SENTRY_ENV } from '../../config';
import { executeHttpRequest } from '../../epics/api';

const AppVersion = () => {
    const [backendVersion, setBackendVersion] = useState(null);
    const [backendConfiguration, setbackendConfiguration] = useState(null);
    const [isLoadingBackendVersion, setIsLoadingBackendVersion] = useState(false);
    const [backendVersionError, setBackendVersionError] = useState(null);

    const date = preval`module.exports = new Date().toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
});`;

    // Fetch backend version from API endpoint
    const fetchBackendVersion = async() => {
        setIsLoadingBackendVersion(true);
        setBackendVersionError(null);

        try {
            const response = await executeHttpRequest('system-info/');
            const data = response.data || {};
            const content = data.content || {};
            const backendVersionArray = content.BACKEND_VERSION;
            const backendVersionString = Array.isArray(backendVersionArray)
                ? backendVersionArray.join('.')
                : 'Unknown';
            setBackendVersion(backendVersionString);
            setbackendConfiguration(content.DJANGO_CONFIGURATION || null);
        } catch (error) {
            setBackendVersionError('Failed to fetch backend version');
        } finally {
            setIsLoadingBackendVersion(false);
        }
    };

    useEffect(() => {
        fetchBackendVersion();
    }, []);

    const renderBackendVersionCell = () => {
        if (isLoadingBackendVersion) {
            return (
                <span className="version-info">
                    <i className="icon icon-loading-1" /> Loading...
                </span>
            );
        }
        if (backendVersionError) {
            return (
                <span className="version-info version-info--error">
                    {backendVersionError}
                </span>
            );
        }
        return (
            <span className="version-info version-info--version">
                {backendVersion || 'Unknown'}
            </span>
        );
    };

    const renderBackendConfigurationCell = () => {
        if (isLoadingBackendVersion) {
            return (
                <span className="version-info">
                    <i className="icon icon-loading-1" /> Loading...
                </span>
            );
        }
        if (backendVersionError) {
            return (
                <span className="version-info version-info--error">
                    {backendVersionError}
                </span>
            );
        }
        return (
            <span className="version-info version-info--environment">
                {backendConfiguration || 'Unknown'}
            </span>
        );
    };

    return (
        <div className="system-settings-section">
            <div className="system-settings-section__header">
                <div className="system-settings-section__title">
                    Application Information
                </div>
            </div>
            <div className="system-settings-section__content">
                <div className="system-settings-section__subtitle">
                    Frontend Application
                </div>
                <table className="table-settings">
                    <tbody>
                        <tr>
                            <td>
                                <span>App Version</span>
                            </td>
                            <td>
                                <span className="version-info version-info--version">
                                    {VERSION || 'None'}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Build Date</span>
                            </td>
                            <td>
                                <span className="version-info">
                                    {date}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Environment</span>
                            </td>
                            <td>
                                <span className="version-info version-info--environment">
                                    {SENTRY_ENV || 'Local'}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div className="system-settings-section__subtitle">
                    Backend Application
                </div>
                <table className="table-settings">
                    <tbody>
                        <tr>
                            <td>
                                <span>Backend Version</span>
                            </td>
                            <td>
                                {renderBackendVersionCell()}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Environment</span>
                            </td>
                            <td>
                                {renderBackendConfigurationCell()}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AppVersion;
